// extracted by mini-css-extract-plugin
export default {"Primary":"Primary___gFNVQ","Transparent":"Transparent___yWl8v","Danger":"Danger___BbhNU","Minor":"Minor___XZVPb"};